import React, {Component} from 'react';
import {connect} from 'react-redux'
import bindAll from 'lodash.bindall';
import HomeComponent from '../components/home/home.jsx';
import {closeHomeModal,openClassdataModal,openRankingListModal,openStudentinfoModal,openActivityListModal,openZipingListModal,
openActivityShenheModal} from "../redux/actions/modelsActive";
import EvaluateComponent from '../containers/evaluate.jsx';
import EvaluateClassComponent from '../containers/evaluateclass.jsx';
import ClassGuanliComponent from '../containers/classGuanli.jsx';
import {getClassSearchInfoRequest,getClassListRequest,getStudentListRequest,getClassInfoRequest} from "../service/user";
import {FILE_URL} from "../util/constants";
import ResultPrompt from '../components/evaluate/resultPrompt/prompt.jsx';
import RecordPrompt from './record.jsx';
import RecordClassPrompt from './recordclass.jsx';
import BadgePrompt from './badge.jsx';
import LogOutPrompt from '../components/prompt/prompt.jsx';
import PubSub from 'pubsub-js';

import defaultImg from '../img/bee.png';
import defaultClassImg from '../img/defaultClassPic.png';

import styles from "../components/home/home.module.css";

class InfoContainer extends React.Component {

    constructor(props) {
        super(props)
        bindAll(this, [
            'hideAllMenu',
            'close',
            'openClassValue',
            'getClassValue',
            'openClassValue2',
            'getClassValue2',
            'openClassValue3',
            'getClassValue3',
            'showReasonPrompt',
            'showReasonPrompt2',
            'closeEvaluatePrompt',
            'selectAll',
            'pingjiaDuoren',
            'cancelPingjiaDuoren',
            'selectChildCheckBox',
            'searchStudent',
            'searchInputChange',
            'pingjiaFinish',
            'openRecord',
            'closeRecord',
            'handleScroll',
            'logOut',
            'quit',
            'deleteFinish',
            'handleImageErrored',
            'getClassInfo',
            'openBanjiReason',
            'pingjiaClassFinish',
            'openRecordClass',
            'deleteClassFinish',
            'openRecordBadge',
            'openClassdataModal',
            'openRankingListModal',
            'openActivityListModal',
            'openZipingListModal',
            'classGuanli',
            'closeClassGuanli',
            'getClassSearchInfo',
            'openHuodongShenheModal'
        ]);
        this.state = {
            searchInputValue:'',
            duorenStatus:false,
            selectAllStatus:false,
            showResultPrompt:false,
            showRecordPrompt:false,
            option: {},
            num:9,
            badgeList:[],
            xuekeList:[],
            showEvaluatePrompt:false,
            student_name:'',
            student_img:'',
            student_pid:'',
            studentList:[],
            studentOldList:[],
            studentSearchList:[],
            jueseList:[],
            juese_code:'',
            juese_name:'',
            showJuese:false,
            nianjiList:[],
            nianji_code:'',
            nianji_name:'',
            showNianji:false,
            banjiList:[],
            banji_code:'',
            banji_name:'',
            showBanji:false,
            isBottom: false,
            showLogOutPrompt:false,
            class_dianzan_num:'',//取class_pingjia_dianzan字段
            class_stu_dianzan_num:'',//取class_dianzan字段
            class_badge_num:'',
            showClassEvaluatePrompt:false,
            showRecordClassPrompt:false,
            showBadgePrompt:false,
            class_img: defaultClassImg,
            huodong_status:0,
            showClassGuanliPrompt:false,
            check_bzr:0
        }

        PubSub.subscribe('kerenUpdate', (event, data) => {
            console.log('科任更新');

            this.getClassSearchInfo()


        });
    }

    componentDidMount() {

        //window.addEventListener('scroll', this.handleScroll, true);

        document.addEventListener('click', this.hideAllMenu);
        this.getClassSearchInfo()

    }

    getClassSearchInfo(){
        getClassSearchInfoRequest( (data) => {
            console.log(data)
            if(data.ret=='1'){
                this.setState({
                    jueseList:data.data.juese_nianji,
                    nianjiList:data.data.juese_nianji[0].nianji,
                    juese_name:data.data.juese_nianji[0].juese_name,
                    juese_code:data.data.juese_nianji[0].juese_code,
                    nianji_name:data.data.juese_nianji[0].nianji[0].nianji_name,
                    nianji_code:data.data.juese_nianji[0].nianji[0].nianji_code
                });

                var juese_code = data.data.juese_nianji[0].juese_code;
                var nianji_code = data.data.juese_nianji[0].nianji[0].nianji_code;

                this.getClassList(juese_code,nianji_code)

            }else {

            }
        });
    }

    componentWillUnmount() {
        //window.removeEventListener('scroll', this.handleScroll, true);
    }

    classGuanli(){
        this.setState({
            showClassGuanliPrompt:true
        })
    }

    closeClassGuanli(){
        this.setState({
            showClassGuanliPrompt:false
        })
    }

    openClassdataModal(){
        sessionStorage.setItem('classcode',this.state.banji_code);
        sessionStorage.setItem('reportBanji',this.state.nianji_name + this.state.banji_name)
        this.props.openClassdataModal();
    }

    openRankingListModal() {
        sessionStorage.setItem('classcode',this.state.banji_code);
        this.props.openRankingListModal();
    }

    openZipingListModal(){
        sessionStorage.setItem('classcode',this.state.banji_code);
        this.props.openZipingListModal();

    }

    openActivityListModal(){
        sessionStorage.setItem('classcode',this.state.banji_code);
        this.props.openActivityListModal();
    }

    openHuodongShenheModal(){
        this.props.openActivityShenheModal()
    }

    handleImageErrored(index){


                var list = this.state.studentList;
                list[index].img = defaultImg;

                this.setState({
                    studentList:list,
                    studentOldList:list
                });
    }

    openRecordClass(){
        this.setState({
            showRecordClassPrompt:true
        })
        this.getClassInfo(this.state.banji_code)
    }

    openRecordBadge(){
        this.setState({
            showBadgePrompt:true
        })
        this.getClassInfo(this.state.banji_code)
    }

    quit(){
        this.setState({
            showLogOutPrompt:false
        })
        window.sessionStorage.clear();
        this.props.closeHomeModal();
        PubSub.publish('loginOut', '');
    }

    logOut(){
        var show = !this.state.showLogOutPrompt;
        this.setState({
            showLogOutPrompt:show
        })
    }

    openRecord(){
        this.setState({
            showRecordPrompt:true
        })
        this.getClassInfo(this.state.banji_code)
    }
    closeRecord(){
        this.setState({
            showRecordPrompt:false,
            showRecordClassPrompt:false,
            showBadgePrompt:false
        })
    }

    openBanjiReason(){
        this.setState({
            showClassEvaluatePrompt:true
        })

    }

    getClassList(juese_code,nianji_code){
        getClassListRequest(juese_code,nianji_code, (data) => {
            console.log(data)

            if(data.data==''){
                this.setState({
                    banjiList:[],
                    banji_name:'',
                    banji_code:'',
                    studentList:[],
                    studentOldList:[]
                });
            }else {
                this.setState({
                    banjiList:data.data,
                    banji_name:data.data[0].name,
                    banji_code:data.data[0].classcode
                });
                this.getStudentList(data.data[0].classcode);
                this.getClassInfo(data.data[0].classcode);
            }

        });
    }

    getClassInfo(class_code){
        getClassInfoRequest(class_code, (data) => {
            console.log(data)

            if(data.ret=='1'){
                this.setState({
                    class_dianzan_num:parseInt(data.data.class_pingjia_dianzan) +  parseInt(data.data.class_pingjia_gaijin),
                    class_stu_dianzan_num:data.data.class_dianzan,
                    class_badge_num:data.data.class_badge,
                    class_img:FILE_URL+data.data.classpic,
                    huodong_status:data.data.huodong_status,
                    check_bzr:data.data.check_bzr
                });

                sessionStorage.setItem('check_bzr',data.data.check_bzr)


            }else {

            }

        });
    }

    handleScroll(event) {

        const clientHeight = event.target.clientHeight
        const scrollHeight = event.target.scrollHeight
        const scrollTop = event.target.scrollTop

        var plusHeight = clientHeight + parseInt(scrollTop);
        var isBottom = (plusHeight === scrollHeight)


        if (isBottom) {
            console.log('加载更多')
        } else {
            console.log('没到达底部')
        }

        if (plusHeight == scrollHeight) {

            // getStudentListRequest(this.state.banji_code,this.state.studentList.length, (data) => {
            //     console.log(data)
            //
            //     if(data.data==''){
            //
            //     }else {
            //         var list = data.data;
            //         for (let i = 0; i < list.length; i++) {
            //             list[i].img = list[i].img==null||list[i].img==''?'':FILE_URL+list[i].img
            //         }
            //         this.setState({
            //             studentList:this.state.studentList.concat(data.data),
            //             studentOldList:this.state.studentOldList.concat(data.data)
            //         });
            //     }
            //
            // });


        }
    }

    getStudentList(class_code){
        getStudentListRequest(class_code, (data) => {
            console.log(data)

            if(data.data==''||data.data==[]){
                this.setState({
                    studentList:[],
                    studentOldList:[]
                });
            }else {

                var list = data.data;
                for (let i = 0; i < list.length; i++) {
                    list[i].img = list[i].img==null||list[i].img==''?'':FILE_URL+list[i].img
                }
                this.setState({
                    studentList:list,
                    studentOldList:list
                });
            }

        });
    }

    hideAllMenu(){
        this.setState({
            showJuese:false,
            showNianji:false,
            showBanji:false
        });
    }

    close(){
        this.props.closeHomeModal()
    }

    searchInputChange (name) {
        this.setState({
            searchInputValue: name.replace(/\s/g, '')
        });
    }

    searchStudent(){

        this.setState({
            selectAllStatus: false,
            duorenStatus:false
        });

        var tempList = []
        this.state.studentOldList.forEach(element => {
            if (element.name.indexOf(this.state.searchInputValue) != -1) {
                tempList.push(element)
            }
        });
        this.setState({
            studentList: tempList
        })
    }

    getClassValue(code,name,index){
        if(code==this.state.juese_code){

        }else {
            this.setState({
                nianjiList:this.state.jueseList[index].nianji,
                nianji_name:this.state.jueseList[index].nianji[0].nianji_name,
                nianji_code:this.state.jueseList[index].nianji[0].nianji_code
            });


            var juese_code = code;
            var nianji_code = this.state.jueseList[index].nianji[0].nianji_code;
            this.getClassList(juese_code,nianji_code)
        }
        this.setState({
            juese_code:code,
            juese_name:name,
            showJuese:false
        })
        this.setState({
            selectAllStatus: false,
            duorenStatus:false
        });
    }

    openClassValue(e){
        e.nativeEvent.stopImmediatePropagation();
        var show = !this.state.showJuese;
        this.setState({
            showJuese:show,
            showNianji:false,
            showBanji:false
        })
    }

    getClassValue2(code,name){
        if(code==this.state.nianji_code){

        }else {
            this.getClassList(this.state.juese_code,code)
        }
        this.setState({
            nianji_code:code,
            nianji_name:name,
            showNianji:false
        });
        this.setState({
            selectAllStatus: false,
            duorenStatus:false
        });

    }

    openClassValue2(e){
        e.nativeEvent.stopImmediatePropagation();
        var show = !this.state.showNianji;
        this.setState({
            showJuese:false,
            showNianji:show,
            showBanji:false
        })
    }

    getClassValue3(code,name){
        if(code==this.state.banji_code){

        }else {
            this.getStudentList(code);
            this.getClassInfo(code);
        }

        this.setState({
            banji_code:code,
            banji_name:name,
            showBanji:false
        });
        this.setState({
            selectAllStatus: false,
            duorenStatus:false
        });
    }

    openClassValue3(e){
        e.nativeEvent.stopImmediatePropagation();
        var show = !this.state.showBanji;
        this.setState({
            showJuese:false,
            showNianji:false,
            showBanji:show
        })
    }

    closeSelf(){
        this.setState({
            showEvaluatePrompt:false
        })
    }

    selectAll(){
        var status = !this.state.selectAllStatus;
        this.setState({
            selectAllStatus: status
        });
        if (this.state.selectAllStatus) {
            console.log('之前已选中');

            var list = [];
            for (var i = 0; i < this.state.studentList.length; i++) {
                list.push(this.state.studentList[i]);
            }
            for (var i = 0; i < this.state.studentList.length; i++) {
                list[i]['checked'] = false;
            }
            this.setState({
                studentList: list
            });
        } else {
            console.log('之前未选中');

            var list = [];
            for (var i = 0; i < this.state.studentList.length; i++) {
                list.push(this.state.studentList[i]);
            }
            for (var i = 0; i < this.state.studentList.length; i++) {
                list[i]['checked'] = true;
            }
            this.setState({
                studentList: list
            });
        }
    }

    pingjiaDuoren(){
        this.setState({
            duorenStatus: true,
            students: this.state.studentOldList,
            inputValue: '',
            selectAllStatus:false
        });
    }
    cancelPingjiaDuoren () {
        this.setState({
            duorenStatus: false,
            selectAllStatus: false
        });

        this.setState({
            studentList: this.state.studentList.map((item, index, arr) => {
                return {...item, checked: false};
            })
        });

        this.setState({
            studentOldList: this.state.studentOldList.map((item, index, arr) => {
                return {...item, checked: false};
            })
        });
    }

    selectChildCheckBox (username,e) {

        e.stopPropagation();
        e.cancelBubble = true;

        var list = [];
        for (var i = 0; i < this.state.studentList.length; i++) {
            list.push(this.state.studentList[i]);
        }
        for (var i = 0; i < this.state.studentList.length; i++) {
            if (this.state.studentList[i].name === username) {
                list[i]['checked'] = !list[i]['checked'];
            }
        }
        this.setState({
            studentList: list
        });


        if (this.state.studentList.every(this.allTest)) {
            this.setState({
                selectAllStatus: true
            });
        } else {
            this.setState({
                selectAllStatus: false
            });
        }

    }

    showReasonPrompt (name, img, pid) {

        if (this.state.duorenStatus) {
            //多人状态下点击item不做处理

            var list = [];
            for (var i = 0; i < this.state.studentList.length; i++) {
                list.push(this.state.studentList[i]);
            }
            for (var i = 0; i < this.state.studentList.length; i++) {
                if (this.state.studentList[i].name === name) {
                    list[i]['checked'] = !list[i]['checked'];
                }
            }
            this.setState({
                studentList: list
            });


            if (this.state.studentList.every(this.allTest)) {
                this.setState({
                    selectAllStatus: true
                });
            } else {
                this.setState({
                    selectAllStatus: false
                });
            }


        } else {
            this.setState({
                student_name: name,
                student_img: img,
                student_pid: pid,
                showEvaluatePrompt:true
            });

            //this.getReasonList();
        }
    }

    showToast(msg,duration){
        duration=isNaN(duration)?3000:duration;
        var m = document.createElement('div');
        m.innerHTML = msg;
        m.style.cssText="min-width:180px; background:#000; opacity:0.6; height:auto;min-height: 30px; color:#fff; line-height:30px; text-align:center; border-radius:4px; position:fixed; top:45%; left:50%;transform: translate(-50%,-50%);padding:15px; z-index:999999;";
        document.body.appendChild(m);
        setTimeout(function() {
            var d = 0.5;
            m.style.webkitTransition = '-webkit-transform ' + d + 's ease-in, opacity ' + d + 's ease-in';
            m.style.opacity = '0';
            setTimeout(function() { document.body.removeChild(m) }, d * 1000);
        }, duration);
    }

    showReasonPrompt2 () {
        if (this.checkAllFalse(this.state.studentList)) {
            // alert('请先选择学生')
            this.showToast('请先选择学生',1500);
            //this.props.showAlert('请先选择学生!');

        } else {

            //this.getReasonList();

            this.setState({
                showEvaluatePrompt: true,
                student_name: '',
                student_img: '',
                student_pid:''
            });

            var list = [];
            var list2 = [];
            for (var i = 0; i < this.state.studentList.length; i++) {
                if (this.state.studentList[i].checked === true) {
                    list.push(this.state.studentList[i].name);
                    list2.push(this.state.studentList[i].pid);
                }
            }
            var names = list.join(',');
            var usernames = list2.join(',');
            console.log('学生的code');
            console.log(names);
            console.log(usernames);

            this.setState({
                showEvaluatePrompt: true,
                student_name: names,
                student_pid: usernames
            });
        }
    }

    closeEvaluatePrompt () {
        this.setState({
            showEvaluatePrompt: false,
            showClassEvaluatePrompt:false
        });
    }
    allTest (item) {
        if (item['checked'] === true) {
            return true;
        } else {
            return false;
        }
    }

    checkAllFalse (arr) {
        var flag = true;
        for (let i = 0, len = arr.length; i < len; i++) {
            if (arr[i]['checked']) {
                flag = false;
                return false;
            }
        }

        return flag;
    }

    pingjiaFinish(){
        this.setState({
            showResultPrompt:true,
        })

        setTimeout(() => {
            this.setState({
                showResultPrompt: false,
                // duorenStatus: false
            });
        }, 2000);

        this.getClassInfo(this.state.banji_code)

        getStudentListRequest(this.state.banji_code, (data) => {
            console.log(data)

            if(data.data==''||data.data==[]){
                this.setState({
                    studentList:[],
                    studentOldList:[]
                });
            }else {

                var oldList = this.state.studentList;


                var list = data.data;
                for (let i = 0; i < list.length; i++) {
                    list[i].img = list[i].img==null||list[i].img==''?'':FILE_URL+list[i].img
                    list[i]['checked'] = oldList[i]['checked']
                }
                this.setState({
                    studentList:list,
                    studentOldList:list
                });

                var tempList = []
                this.state.studentOldList.forEach(element => {
                    if (element.name.indexOf(this.state.searchInputValue) != -1) {
                        tempList.push(element)
                    }
                });
                this.setState({
                    studentList: tempList
                })

            }

        });
    }

    pingjiaClassFinish(){
        this.setState({
            showResultPrompt2:true,
        })

        setTimeout(() => {
            this.setState({
                showResultPrompt2: false,
            });
        }, 2000);
        this.getClassInfo(this.state.banji_code)
    }

    deleteFinish(){
        getStudentListRequest(this.state.banji_code, (data) => {
            console.log(data)

            if(data.data==''||data.data==[]){
                this.setState({
                    studentList:[],
                    studentOldList:[]
                });
            }else {
                var list = data.data;
                for (let i = 0; i < list.length; i++) {
                    list[i].img = list[i].img==null||list[i].img==''?'':FILE_URL+list[i].img
                }
                this.setState({
                    studentList:list,
                    studentOldList:list
                });

                var tempList = []
                this.state.studentOldList.forEach(element => {
                    if (element.name.indexOf(this.state.searchInputValue) != -1) {
                        tempList.push(element)
                    }
                });
                this.setState({
                    studentList: tempList
                })

                this.getClassInfo(this.state.banji_code)

            }

        });
    }

    deleteClassFinish(){
        this.getClassInfo(this.state.banji_code)
    }


    render() {

        return (
            <div className={styles.ziti}>

                <HomeComponent
                    duorenStatus={this.state.duorenStatus}
                    selectAllStatus={this.state.selectAllStatus}
                    close={this.close}
                    xuekeList={this.state.xuekeList}
                    juese_name={this.state.juese_name}
                    showJuese={this.state.showJuese}
                    jueseList={this.state.jueseList}
                    openClassValue={this.openClassValue}
                    getClassValue={this.getClassValue}
                    nianji_name={this.state.nianji_name}
                    showNianji={this.state.showNianji}
                    nianjiList={this.state.nianjiList}
                    openClassValue2={this.openClassValue2}
                    getClassValue2={this.getClassValue2}
                    banji_name={this.state.banji_name}
                    showBanji={this.state.showBanji}
                    banjiList={this.state.banjiList}
                    openClassValue3={this.openClassValue3}
                    getClassValue3={this.getClassValue3}
                    studentList={this.state.studentList}
                    search={this.searchStudent}
                    showReasonPrompt={this.showReasonPrompt}
                    showReasonPrompt2={this.showReasonPrompt2}
                    selectAll={this.selectAll}
                    pingjiaDuoren={this.pingjiaDuoren}
                    cancelPingjiaDuoren={this.cancelPingjiaDuoren}
                    selectChildCheckBox={this.selectChildCheckBox}
                    searchInputChange={this.searchInputChange}
                    searchInputValue={this.state.searchInputValue}
                    openRecord={this.openRecord}
                    openRecordClass={this.openRecordClass}
                    openRecordBadge={this.openRecordBadge}
                    logOut={this.logOut}
                    handleImageErrored={this.handleImageErrored}
                    class_dianzan_num={this.state.class_dianzan_num}
                    class_stu_dianzan_num={this.state.class_stu_dianzan_num}
                    class_badge_num={this.state.class_badge_num}
                    openBanjiReason={this.openBanjiReason}
                    openClassdataModal={this.openClassdataModal}
                    openRankingListModal={this.openRankingListModal}
                    openActivityListModal={this.openActivityListModal}
                    huodong_status={this.state.huodong_status}
                    openZipingListModal={this.openZipingListModal}
                    classGuanli={this.classGuanli}
                    openHuodongShenheModal={this.openHuodongShenheModal}
                />
                {this.state.showEvaluatePrompt?
                    <EvaluateComponent
                        closeSelf={this.closeEvaluatePrompt}
                        student_name={this.state.student_name}
                        student_pid={this.state.student_pid}
                        banji_code={this.state.banji_code}
                        duorenStatus={this.state.duorenStatus}
                        pingjiaFinish={this.pingjiaFinish}
                    />
                :null}

                {this.state.showClassEvaluatePrompt?
                    <EvaluateClassComponent
                        closeSelf={this.closeEvaluatePrompt}
                        student_name={this.state.banji_name}
                        student_pid={this.state.student_pid}
                        banji_code={this.state.banji_code}
                        duorenStatus={this.state.duorenStatus}
                        pingjiaClassFinish={this.pingjiaClassFinish}
                    />
                :null}

                {this.state.showResultPrompt ?
                    <ResultPrompt
                        student_img={this.state.student_img}
                        student_name={this.state.student_name}
                        type='1'
                        duorenStatus={this.state.duorenStatus}
                    /> : null}

                {this.state.showResultPrompt2 ?
                    <ResultPrompt
                        student_img={this.state.class_img}
                        student_name={this.state.banji_name}
                        type='1'
                        duorenStatus={this.state.duorenStatus}
                    /> : null}

                {this.state.showRecordPrompt ?
                    <RecordPrompt
                        banji_code={this.state.banji_code}
                        closeRecord={this.closeRecord}
                        deleteFinish={this.deleteFinish}
                    /> : null}

                {this.state.showRecordClassPrompt ?
                    <RecordClassPrompt
                        banji_code={this.state.banji_code}
                        closeRecord={this.closeRecord}
                        deleteClassFinish={this.deleteClassFinish}
                    /> : null}

                {this.state.showBadgePrompt ?
                    <BadgePrompt
                        banji_code={this.state.banji_code}
                        closeRecord={this.closeRecord}
                    /> : null}

                {this.state.showLogOutPrompt?
                <LogOutPrompt
                    label='退出登录'
                    title='是否退出登录？'
                    onCancel={this.logOut}
                    onOk={this.quit}
                />
                :null}

                {this.state.showClassGuanliPrompt?
                    <ClassGuanliComponent
                        closeSelf={this.closeClassGuanli}
                    />
                    :null}

            </div>

        )
    }


}

InfoContainer.propTypes = {
    // count: PropTypes.Number.isRequired,
}


const mapStateToProps = state => {
    return {
        msg: state.alert.msg,
        status: state.alert.status,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        closeHomeModal:() => dispatch(closeHomeModal()),
        openClassdataModal:() => dispatch(openClassdataModal()),
        openRankingListModal:() => dispatch(openRankingListModal()),
        openStudentinfoModal:() => dispatch(openStudentinfoModal()),
        openActivityListModal:() => dispatch(openActivityListModal()),
        openZipingListModal:() => dispatch(openZipingListModal()),
        openActivityShenheModal:() => dispatch(openActivityShenheModal()),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(InfoContainer);
